import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PaginationPage } from 'src/app/classes';
import { DefaultNotification } from 'src/app/lib/default-notification/classes';
import { IssueService } from '../../../services/issue.service';

@Component({
  selector: 'app-select-default-notification',
  templateUrl: './select-default-notification.component.html',
  styleUrls: ['./select-default-notification.component.css'],  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectDefaultNotificationComponent),
      multi: true
    }
  ]
})
export class SelectDefaultNotificationComponent implements ControlValueAccessor, OnDestroy, OnInit {

  @Input() multiple: boolean = false;
  @Input() label: string = 'Standardbenachrichtigung wählen';
  @Input() appearance: 'fill' | 'outline' | 'standard' = 'fill';

  defaultNotifications: DefaultNotification[] = [];

  formControl: FormControl = new FormControl();

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 20 };
  totalItems: number = 0;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _issueService: IssueService
  ) { }

  loadDefaultNotifications(){
    this._issueService.getDefaultNotifications(this.page).subscribe((result) => {
      if(result.page.pageNumber === 1) this.defaultNotifications = [];
      this.totalItems = result.totalItems;
      this.defaultNotifications = [...this.defaultNotifications, ...result.content];
      this.page = result.page;
    });
  }

  loadMore(){
    this.page.pageNumber++;
    this.loadDefaultNotifications();
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.loadDefaultNotifications();
  }

  public onTouched: () => void = () => { };
  registerOnTouched = (fn: any) => this.onTouched = fn;

  registerOnChange(fn: any): void {
    this._subscriptions.push(this.formControl.valueChanges.subscribe(fn));
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(val: any): void {
    if (val) this.formControl.setValue(val);
  }

}
